<template>
    <span>{{dispatcherTypeDisplay}}</span>
</template>

<script>
    export default {
        name: 'dispatcher-type',

        props: {
            type: {required: true},
            name: {required: true},
        },

        computed: {
            dispatcherTypeDisplay() {
                switch (this.type) {
                    case 'dc':
                        return 'DC ' + this.name
                    default:
                        return this.name
                }
            }
        }
    }
</script>
